<template>
  <Row class-name="bodys" :style="{ 'min-height': `${$store.state.init.offsetHeight - 251}px` }">
    <Col span="24">
      <BreadcrumbWrap />
    </Col>
    <Col span="24">
      <p class="step">第一步：档案检索</p>
      <EngTable @on-click-row="openArchsTable" @on-init-table="initArchsFilesTable" />
      <p class="step">第二步：查档申请</p>
      <div class="split">
        <ArchsTable ref="archsTable" @on-click-row="openFilesTable" @on-init-table="initFilesTable" />
        <FilesTable ref="filesTable" :selection="selection" @on-select="addApply" @on-select-cancel="delApply" :engSid="engSid" />
      </div>
    </Col>
    <Col span="24">
      <p class="step">第三步：查档信息登记</p>
      <div class="btn">
        <slot>
          <Button
            type="primary"
            @click="handleToName('reservation')"
          >{{ $config.operateButtonText[0] }}</Button>
          <Button
            type="primary"
            @click="handleToName('online')"
          >{{ $config.operateButtonText[1] }}</Button>
        </slot>
      </div>
      <SelectionTable :selection="selection" @on-select-cancel="delApply" />
    </Col>
  </Row>
</template>

<script>
import EngTable from './engTable'
import ArchsTable from './archsTable'
import FilesTable from './filesTable'
import SelectionTable from './selectionTable'
import BreadcrumbWrap from '@components/breadcrumb-wrap'
export default {
  name: 'search',
  components: { EngTable, ArchsTable, FilesTable, SelectionTable, BreadcrumbWrap },
  props: {
    selectFiles: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selection: [],
      engSid: ''
    }
  },
  watch: {
    selectFiles: {
      handler (val) {
        this.selection = val
      },
      deep: true
    }
  },
  methods: {
    openArchsTable (row) {
      this.engSid = row.SID
      this.$refs['archsTable'].init(row)
    },
    openFilesTable (row) {
      this.$refs['filesTable'].init(row)
    },
    addApply (row) {
      if (this.selection.length >= 80) {
        this.$Message.warning('最多只能申请80条')
        return
      }
      this.selection.push(row)
    },
    delApply (row) {
      const index = this.selection.findIndex(f => f.SID === row.SID)
      index > -1 && this.selection.splice(index, 1)
    },
    initArchsFilesTable () {
      this.$refs['archsTable'].init()
      this.$refs['filesTable'].init()
    },
    initFilesTable () {
      this.$refs['filesTable'].init()
    },
    handleToName (name) {
      if (!this.selection.length) {
        this.$Message.warning('请至少选择一项需要申请的文件')
        return
      }
      this.$Modal.confirm({
        title: '提示',
        content: this.$config.disclaimer,
        onOk: () => {
          this.$router.push({
            name,
            params: {
              item: this.selection
            },
            query: this.$route.meta.query ? this.$route.query : ''
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
$md: 768px;
.bodys {
  background: #fff;
  border-top: 2px solid $default;
  padding: 16px;
}
.step {
  margin-top: 16px;
  color: $default;
  font-weight: bold;
}
.split {
  width: 100%;
  &>div {
    width: calc(50% - 8px);
    display: inline-block;
    vertical-align: top;
    &:first-child {
      margin-right: 16px;
    }
  }
}
.btn {
  margin-top: 16px;
  .ivu-btn {
    margin: 0 6px;
  }
}
</style>
